export class QuantityAdjuster extends window.BAO.CustomElement() {
  static get observedAttributes () {
    return ['value', 'disabled', 'min', 'max']
  }

  constructor () {
    super()

    this.setup()
  }

  connectedCallback () {
    super.connectedCallback()

    if (!this.hasAttribute('value')) {
      this.setAttribute('value', this.min.toString())
    }

    if (!this.hasAttribute('min')) {
      this.setAttribute('value', this.min.toString())
    }

    // this.plusButton.disabled = this.max === 0

    this._upgradeProperty('value')
    this._upgradeProperty('disabled')
  }

  attributeChangedCallback (name, oldValue, newValue) {
    const isANumber = isNaN(parseInt(newValue, 10)) === false

    switch (name) {
      case 'value': {
        if (!isANumber) break
        if (parseInt(oldValue, 10) === parseInt(newValue, 10)) break

        this.handleValueChangeSideEffects(parseInt(newValue, 10))

        break
      }
      case 'min': {
        if (!isANumber) break

        if (this.value < parseInt(newValue, 10)) {
          this.value = parseInt(newValue, 10)
        }

        break
      }
      case 'max': {
        if (!isANumber) break

        if (this.value > parseInt(newValue, 10)) {
          this.value = parseInt(newValue, 10)
        }

        if (this.max != null && this.value === this.max) {
          this.plusButton.disabled = true
        } else if (this.plusButton.dataset.shouldBeDisabled === 'false') {
          this.plusButton.disabled = false
        }

        if (this.min === this.max) {
          this.input.disabled = true
        } else if (this.input.dataset.shouldBeDisabled === 'false') {
          this.input.disabled = false
        }

        break
      }
      case 'disabled': {
        const hasValue = newValue != null

        this.minusButton.disabled = hasValue
        this.plusButton.disabled = hasValue
        this.input.disabled = hasValue
      }
    }
  }

  setup () {
    this.input.setAttribute('value', this.value.toString())
    this.input.value = this.value.toString()
    this.input.name = this.name

    if (this.value === this.initialValue) {
      this.minusButton.disabled = true
    }
  }

  setupListeners () {
    super.setupListeners()

    this.onMinusClick = this.onMinusClick.bind(this)
    this.onPlusClick = this.onPlusClick.bind(this)
    this.onInputChange = this.onInputChange.bind(this)
    this.onInputInput = this.onInputInput.bind(this)

    this.listeners.add(this.minusButton, 'click', this.onMinusClick)
    this.listeners.add(this.plusButton, 'click', this.onPlusClick)
    this.listeners.add(this.input, 'change', this.onInputChange)
    this.listeners.add(this.input, 'input', this.onInputInput)

    if (this.productDetailBlocksEl) {
      this.onVariantChange = this.onVariantChange.bind(this)

      this.listeners.add(
        this.productDetailBlocksEl,
        window.BAO.EVENTS.VARIANT.CHANGE,
        this.onVariantChange,
      )
    }
  }

  onVariantChange (event) {
    if (!event?.detail?.inventory?.inventory_quantity) return
    this.max = event.detail.inventory.inventory_quantity
  }

  onMinusClick () {
    if (this.value === this.min) return

    this.value -= 1

    if (document.querySelector('[data-product-quantity-modal-el="trigger"]')) {
      document.querySelector(
        '[data-product-quantity-modal-el="trigger"]',
      ).innerHTML = this.value
      document
        .querySelector('[data-product-quantity-modal-el="trigger"]')
        .setAttribute('value', this.value)
    }
  }

  onPlusClick () {
    this.value += 1

    if (document.querySelector('[data-product-quantity-modal-el="trigger"]')) {
      document.querySelector(
        '[data-product-quantity-modal-el="trigger"]',
      ).innerHTML = this.value
      document
        .querySelector('[data-product-quantity-modal-el="trigger"]')
        .setAttribute('value', this.value)
    }
  }

  /**
   * @param {Event} e
   *
   * @returns {void}
   */
  onInputChange (e) {
    if (isNaN(e.target.valueAsNumber) === false) {
      this.value = e.target.valueAsNumber
    }
  }

  /**
   * @param {InputEvent} e
   *
   * @returns {void}
   */
  onInputInput (e) {
    if (isNaN(e.target.valueAsNumber) === false) {
      this.value = e.target.valueAsNumber
    }

    if (this.max != null && e.target.valueAsNumber > this.max) {
      e.target.value = this.max
    }
  }

  /**
   * @param {Number} val
   *
   * @returns {void}
   */
  handleValueChangeSideEffects (val) {
    const oldVal = this.value

    if (val > this.max) {
      val = this.max
    }

    if (oldVal === val) return

    this.input.value = val.toString()

    this.minusButton.disabled = val === this.min
    this.plusButton.disabled = this.max != null && val === this.max

    this.dispatchEvent(
      new CustomEvent(window.BAO.EVENTS.QUANTITY_ADJUSTER.CHANGE, {
        detail: {
          oldValue: oldVal,
          value: val,
        },
        bubbles: true,
      }),
    )
  }

  /**
   * @param {Number} val
   *
   * @returns {void}
   */
  set value (val) {
    if (val < this.min) {
      val = this.min
    }

    this.handleValueChangeSideEffects(val)

    this.setAttribute('value', val.toString())
  }

  /**
   * @param {Number} val
   *
   * @returns {void}
   */
  set max (val) {
    this.setAttribute('max', String(val))
    this.input.setAttribute('max', String(val))
    this.input.dispatchEvent(new Event('change'))
  }

  /**
   * @returns {Number}
   */
  get value () {
    return parseInt(this.getAttribute('value'), 10)
  }

  /**
   * @returns {Number}
   */
  get min () {
    const min = parseInt(this.getAttribute('min'), 10)
    return min || min === 0 ? min : this.initialValue
  }

  /**
   * @returns {Number|null}
   */
  get max () {
    const max = parseInt(this.getAttribute('max'), 10)
    return max === 0 || max > 0 ? max : null
  }

  /**
   * @returns {String}
   */
  get name () {
    return this.getAttribute('name') || 'quantity'
  }

  /**
   * @returns {HTMLButtonElement}
   */
  get minusButton () {
    return this.els.minus.element
  }

  /**
   * @returns {HTMLButtonElement}
   */
  get plusButton () {
    return this.els.plus.element
  }

  /**
   * @returns {HTMLInputElement}
   */
  get input () {
    return this.els.input.element
  }

  get initialValue () {
    return isNaN(parseInt(this.dataset?.initialValue, 10)) === false
      ? this.dataset.initialValue
      : 1
  }

  /**
   * @returns {HTMLElement|null}
   */
  get productDetailBlocksEl () {
    return this.closest('[data-product-detail-blocks]')
  }
}

if (!customElements.get('quantity-adjuster')) {
  customElements.define('quantity-adjuster', QuantityAdjuster)
}
